module.exports = __webpack_public_path__ + "static/img/JO.327061ae.jpg";